module.exports = __webpack_public_path__ + "img/form-1.b671754.png";